import axios from 'axios'
import {useAuthStore} from "@/stores/auth"

const BASE_URL = process.env.VUE_APP_API_URL
const callAPI = async (path, method, config) => {
    try {
        const res = await axios({
            url: BASE_URL + path,
            method,
            ...config
        })
        return res.data
    } catch (e) {
        return e
    }
}

export const api = {
    getToken () {
        return useAuthStore()
    },
    categories: {
        async get () {
            return await callAPI('/api/category', 'GET', {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        },
        async create (dataForm) {
            return await callAPI('/admin/category', 'POST', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                },
                data: dataForm
            })
        },
        async options () {
            return await callAPI('/api/category/options', 'GET', {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        },
        async getByName (name) {
            return await callAPI(`/api/category/${name}/products`, 'GET', {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }
    },
    products: {
        async get (url = '') {
            return await callAPI('/api/products' + url, 'GET', {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        },
        async create (dataForm) {
            return await callAPI('/admin/products', 'POST', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                },
                data: dataForm
            })
        },
        async upload (form, id) {
            return await callAPI('/admin/products/upload/' + id, 'POST', {
                headers: {
                    'Content-Type': 'multipart/auth-data; boundary=---011000010111000001101001',
                    'Authorization': api.getToken().getToken
                },
                data: form
            })
        },
        async getById (tag) {
            return await callAPI('/api/products/' + tag, 'GET', {
                headers: {
                    'Content-Type': 'application/json'
                },
            })
        },
        async update (id, formData) {
            return await callAPI('/admin/products/' + id, 'PUT', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                },
                data: formData
            })
        },
        async options () {
            return await callAPI('/api/products/options', 'GET')
        },
        async getSimilaryProducts (categoryId) {
            return await callAPI('/api/products/similary-products/' + categoryId, 'GET')
        }
    },
    auth: {
        async login (dataForm) {
            return await callAPI('/auth/login', 'POST', {
                data: dataForm
            })
        },
        async register (dataForm) {
            return await callAPI('/auth/register', 'POST', {
                data: dataForm
            })
        }
    },
    cart: {
        async get () {
            return await callAPI('/api/cart', 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async addProduct (productId, quantity) {
            return await callAPI(`/api/cart/${productId}`, 'POST', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                },
                data: {
                    quantity
                }
            })
        },
        async deleteProduct (productId) {
            return await callAPI(`/api/cart/${productId}`, 'DELETE', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async validate (formData) {
            return await callAPI('/api/cart/validate', 'POST', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                },
                data: formData
            })
        },
        async getById(id) {
            return await callAPI('/api/cart/' + id, 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async getAllOrder () {
            return await callAPI('/api/cart/all', 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        }
    },
    profil: {
        async get () {
            return await callAPI('/api/profil', 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async createAddress (formData) {
            return await callAPI('/api/profil/address', 'POST', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                },
                data: formData
            })
        },
        async update(formData) {
            return await callAPI('/api/profil', 'POST', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                },
                data: formData
            })
        },
        async getFavorites() {
            return await callAPI('/api/profil/favorite', 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async updateFavorites(productId) {
            return await callAPI('/api/profil/favorite/' + productId, 'POST', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async getDeliveryInformation() {
            return await callAPI('/api/profil/delivery-information', 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async requestResetPassword(formData) {
            return callAPI('/api/profil/request-reset-password', 'POST', {
                headers: {
                    'Content-Type': 'application/json'
                },
                data: formData
            })
        },
        async resetPassword(token, formData) {
            return callAPI('/api/profil/reset-password/' + token, 'POST', {
                headers: {
                    'Content-Type': 'application/json'
                },
                data: formData
            })
        }
    },
    reviews: {
        async create(formData, productId) {
            return await callAPI('/api/reviews/' + productId, 'POST', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                },
                data: formData
            })
        },
        async get(productId) {
            return callAPI('/api/reviews/' + productId, 'GET')
        },
        async getUserReviews() {
            return callAPI('/api/reviews', 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async update(reviewId, formData) {
            return callAPI('/api/reviews/' + reviewId, 'PUT', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                },
                data: formData
            })
        },
        async delete(productId) {
            return callAPI('/api/reviews/' + productId, 'DELETE', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        }
    },
    address: {
        async getById (id){
            return await callAPI('/api/address/' + id, 'GET')
        }
    },
    kpis: {
        async getStatsGeneral () {
            return await callAPI('/admin/kpis/get-stats-general', 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async getStatsUsersByMonth () {
            return await callAPI('/admin/kpis/users-by-month', 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async getStatsOrdersByMonth () {
            return await callAPI('/admin/kpis/orders-by-month', 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async getStatsSalesByProduct () {
            return await callAPI('/admin/kpis/sales-by-product', 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async getStatsSalesByCategory () {
            return await callAPI('/admin/kpis/sales-by-category', 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
    },
    orders: {
        async getOrdersAdmin () {
            return await callAPI('/admin/orders', 'GET', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        },
        async nextStep (id, step) {
            return await callAPI(`/admin/orders/${id}/next-step/${step}`, 'POST', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': api.getToken().getToken
                }
            })
        }
    }
}